import {Component, EventEmitter, Input, Output, ChangeDetectionStrategy} from '@angular/core';
import Product from "../../model/product.model";

import {ProductCardComponent} from "../product-card/product-card.component";
import {ProductType} from "../../types/product.type";

@Component({
    selector: 'app-product-list',
    imports: [
    ProductCardComponent
],
    templateUrl: './product-list.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './product-list.component.scss'
})
export class ProductListComponent {
  @Input() products!: Product[];
  @Input() productType!: ProductType;
  @Output() order: EventEmitter<Product> = new EventEmitter<Product>();

  public sortedProducts(): Product[] {
    return this.products.sort((a: Product, b: Product) => (a.specs.weight ?? 0) > (b.specs.weight ?? 0) ? -1 : 1);
  }
}
